// extracted by mini-css-extract-plugin
export default {"container":"style_container__ORKC9","testimonialsCont":"style_testimonialsCont__OZe8q"};